/** Gap assessment recommendations = comments, owners, and evidence from the form. */

export function gapAttachmentPreviewPath(file) {
  if (!file?.id) return null;
  return `/gap-assessment/attachment/${file.id}/file`;
}

export function tprmAttachmentPreviewPath(file) {
  if (!file?.id) return null;
  return `/tprm/attachment/${file.id}/file`;
}

export function referenceEvidencePreviewPath(evidence) {
  if (!evidence?.id) return null;
  return `/tenant/form-questions/reference-evidence/${evidence.id}/file`;
}

export function referenceEvidenceStatusLabel(status) {
  switch (status) {
    case "ready":
      return "Ready for users";
    case "generating":
    case "pending":
      return "Generating…";
    case "failed":
      return "Generation failed";
    default:
      return status || "Unknown";
  }
}

export const REFERENCE_EVIDENCE_USER_LABEL = "Admin template";
export const REFERENCE_EVIDENCE_USER_TITLE = "Admin-prepared evidence";
export const REFERENCE_EVIDENCE_USER_HINT =
  "Your tenant admin generated this reference document to help you answer this question. Preview or attach it as supporting evidence.";
export const REFERENCE_EVIDENCE_ADMIN_TITLE = "AI reference evidence";
export const REFERENCE_EVIDENCE_ADMIN_HINT =
  "Generated when a question is created. Editing does not regenerate it — click Regenerate if you want a new template.";
export const STORED_EVIDENCE_TABLE_COLUMN = "Stored evidence";
export const STORED_EVIDENCE_TABLE_HINT = "Click to view the evidence file and notes saved for this question.";

export function storedEvidenceStatusLabel(status) {
  switch (status) {
    case "ready":
      return "Stored";
    case "generating":
    case "pending":
      return "Updating";
    case "failed":
      return "Failed";
    case "not_started":
    default:
      return "None";
  }
}

export function formatAttachmentSize(bytes) {
  const n = Number(bytes);
  if (!n || Number.isNaN(n)) return "";
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  return `${(n / (1024 * 1024)).toFixed(1)} MB`;
}

export function isGapRecommendationObject(rec) {
  return rec && typeof rec === "object" && !Array.isArray(rec);
}

export function gapRecommendationLabel(rec, index) {
  if (!isGapRecommendationObject(rec)) return String(rec || "");
  const id = rec.question_id ? `${rec.question_id}` : `Item ${index + 1}`;
  const title = rec.section_title ? ` — ${rec.section_title}` : "";
  return `${id}${title}`;
}

export function gapRecommendationSummary(rec) {
  if (!isGapRecommendationObject(rec)) return String(rec || "");
  const parts = [];
  if (rec.comment) parts.push(rec.comment);
  if (rec.owner) parts.push(`Owner: ${rec.owner}`);
  if (rec.evidence?.length) {
    parts.push(`Evidence: ${rec.evidence.map((f) => f.original_name || f.file_name).join(", ")}`);
  }
  return parts.join(" · ") || rec.question_text || "";
}

export function gapRecommendationToExportQa(rec, index) {
  if (!isGapRecommendationObject(rec)) {
    return {
      question: `Recommendation ${index + 1}`,
      answer: String(rec || ""),
    };
  }
  const evidence = (rec.evidence || [])
    .map((f) => f.original_name || f.file_name)
    .filter(Boolean)
    .join("; ");
  return {
    section: rec.section_title || "",
    question_id: rec.question_id || "",
    question: `${rec.question_id || `Item ${index + 1}`}: ${rec.question_text || ""}`.trim(),
    answer: rec.answer || "",
    note: rec.comment || "",
    owner: rec.owner || "",
    evidence: evidence || undefined,
  };
}
